import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import videoChatImage from '../../images/video-blk.png';
import injectSaga from '../../../../utils/injectSaga';
import injectReducer from '../../../../utils/injectReducer';
import videoChat from '../reducer';
import * as actions from '../actions';
import saga from '../sagas';
import { getCookie, getFlowType, getSession, viewport, getAPPID } from '../../Helpers';
import TextLink from '../../TextLink';
import { StyledWrapper } from '../../styles';
import { getSecureBaseUrl } from '../../../../services/UrlMapperService';

let LQResponseData = getSession('LQResponse');
LQResponseData = JSON.parse(LQResponseData);
const sessionId = getCookie('digital_ig_session');
const zipCode = LQResponseData?.output?.zipCode;
const vzwDLGlobalID = '';
let isMVAChannel = false;
// const videoAssistUrl = '/soe/digital/mediaservice/getmediastats';
const isLTEFlow = false;
let loggedInMDN = '';
const isLoggedIn = getAPPID() === 'AAL';
if (isLoggedIn) {
  loggedInMDN = getSession('MTN');
}

// MTN
// digital_ig_session

const wrapperStyles = `
display: inline-block;
height: 20px;
img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
`;

class VideoChat extends React.Component {
  componentDidMount() {
    const isPreOrder = false;
    const { pathname } = window?.location;
    if (!isLTEFlow && !isPreOrder && window.vzFlags?.enableVideoCall) {
      const videoAssistUrl = `${getSecureBaseUrl(true)}/mediaservice/getmediastats`;
      if (!pathname.includes('progressiveplan') || !pathname.includes('shipping')) {
        this.props.showVideoChatAssisAct(videoAssistUrl, sessionId, zipCode, this.props.showVideoChatAssist, 1);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const isPreOrder = false;
    if (!isLTEFlow && !isPreOrder && window.vzFlags?.enableVideoCall && window?.location?.pathname?.includes('progressiveplan')) {
      const videoAssistUrl = `${getSecureBaseUrl(true)}/mediaservice/getmediastats`;
      if (prevProps?.planDetails !== this.props?.planDetails || prevProps?.getcheckoutDetails !== this.props?.getcheckoutDetails) {
        this.props.showVideoChatAssisAct(videoAssistUrl, sessionId, zipCode, this.props.showVideoChatAssist, 1);
      }
      if (prevProps.shippingDetails !== this.props.shippingDetails && !isLoggedIn) {
        const startTime = new Date().getTime();
        const interval = setInterval(() => {
          if (new Date().getTime() - startTime > 300000) {
            setTimeout(() => this.props.showVideoChatAssisAct(videoAssistUrl, sessionId, zipCode, this.props.showVideoChatAssist, 1), 2000);
            clearInterval(interval);
          }
        }, 5000);
      }
    }
  }

  handleVideoChatClick = (pageName) => {
    let width;
    // let height;
    let left = 0;
    if (window.innerWidth < 720) {
      width = window.innerWidth;
    } else {
      width = 700;
      left = (window.innerWidth - 700) / 3;
    }
    const height = window.innerHeight < 700 ? window.innerHeight : 700;
    const params = `width=${width},height=${height},top=20,left=${left}, resizable=no`;

    const videoChatUrl = `/stores/video-assist?z=${zipCode}&p=5G${pageName}&global=${vzwDLGlobalID}&mdn=${loggedInMDN}`;
    const pass = window.open(videoChatUrl, '_blank', params);
    pass.pageEntry = `5G ${pageName}`;
    pass.locationCode = zipCode;
  };

  isVideoDevTestEnabled = () => getSession('liveSupportDevTest') === 'Y' || getSession('videoSupportServiceDevTest') === 'Y';

  render() {
    const type = viewport();
    if (type === 'mfapp') {
      isMVAChannel = true;
    }
    const isRepavailable = this.props.showVideoChatAssist || this.isVideoDevTestEnabled();
    if (!isRepavailable || isMVAChannel || getFlowType() !== '5G') {
      return null;
    }
    return (
      <StyledWrapper styles={wrapperStyles} id="videoCallBlock">
        <img src={videoChatImage} alt="VideoChat" />
        <TextLink
          id="videoChatCol"
          data-analyticstrack="chat-click:video:icon"
          ariaLabel="Video Call"
          onClick={() => {
            this.handleVideoChatClick(this.props.title);
          }}
          isVideoChat
        >
          Video Call
        </TextLink>
      </StyledWrapper>
    );
  }
}

VideoChat.propTypes = {
  showVideoChatAssist: PropTypes.bool,
  showVideoChatAssisAct: PropTypes.func,
  title: PropTypes.string,
  planDetails: PropTypes.any,
  shippingDetails: PropTypes.any,
  getcheckoutDetails: PropTypes.any,
};

const mapStateToProps = (state) => {
  const showVideoChatAssist = state?.videoChat?.showVideoChatAssist || false;
  const planDetails = state?.progressivePlans?.progressivePlanAPiResponse ? state?.progressivePlans?.progressivePlanAPiResponse : {};
  const shippingDetails = state?.shippingInfo?.ShippingInfoDetails ? state?.shippingInfo?.ShippingInfoDetails : {};

  const getcheckoutDetails = state.checkout?.shipment || {};

  return {
    showVideoChatAssist,
    planDetails,
    shippingDetails,
    getcheckoutDetails,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...actions,
    },
    dispatch,
  );
}

const withSaga = compose(injectSaga({ key: 'commonChat', saga }));

const withReducer = compose(injectReducer({ key: 'videoChat', reducer: videoChat }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withSaga, withReducer, withConnect)(VideoChat);
